const Faqdata = {
    title: "FAQ",
    rows: [
        {
            title: "可以送貨嗎？",
            content: "基本上不支持遠距離送貨服務。但是，請僅在大安區附近的情況下通過電話與我們聯繫。此外，對於其他地區一律不提供服務。",
        },
        {
            title: "店內有限時的規定嗎？",
            content:
                "我們是一家從早上7點點營業到晚上18點的不限的時咖啡廳。",
        },
        {
            title: "店裡有提供座位嗎?",
            content:
                "我們座位安排上除了常見的4人座、多人的大長桌，更貼心地準備了個人座位區。",
        },
        {
            title: "你在找工作嗎？",
            content: "我們目前沒有招聘。",
        },
        {
            title: "你們接受攝影和採訪嗎？",
            content: "我們暫時不接受。但如果您希望這樣做，請來電與我們聯繫。",
        },
    ],
};

export default Faqdata;
